<template>
  <div class="mt-5 div-top">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="title">
            {{ name }}
          </div>
          <!-- desktop e mobile por CSS: o SSR não sabe a largura da tela -->
          <h3 class="description mt-3">
            <span class="descricao-desktop">{{ model.descriptionModel }}</span>
            <span class="descricao-mobile">{{ translate.wallpaper }}</span>
          </h3>
          <p class="ml-5 my-3 text model-info">
            {{ text }}
          </p>
        </div>
        <div class="col-lg-12">
          <div class="row align-items-center my-4 cards-wp">
            <div
              v-for="card in cards"
              class="col-lg-4 col-6 mt-3"
              :key="card.id"
              v-on:click="selectedWallpaper(card)"
            >
              <div class="card-pagination">
                <img
                  class="card-wallpaper-view"
                  :src="card.imgPath"
                  :alt="name"
                />
                <div class="card-body d-flex flex-column align-items-center">
                  <h5 class="card-title my-3">
                    {{ translate.download }}
                    <font-awesome
                      :icon="['fas', 'download']"
                      style="
                        color: #b20000;
                        margin-left: 5px;
                        font-size: 11px;
                        top: -2px;
                      "
                    />
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ClientOnly>
    <Teleport to="body">
      <!-- use the modal component, pass in the prop -->
      <v-modal :show="showModal" @close="openModal">
        <template #header> <!--<h3>{{ 'Wallpaper' }}</h3>-->&nbsp; </template>
        <template #body>
          <img class="img-selected-modal" :src="imgSelected" :alt="name" />
        </template>
        <template #footer>
          <div class="row w-100 align-items-center justify-content-center">
            <h5
              v-if="desktopDownload"
              class="col-lg-3 cursor-pointer down-option"
              id="desk"
              @click="download(true)"
            >
              {{ "Desktop" }}
              <font-awesome
                :icon="['fas', 'download']"
                size="sm"
                style="
                  color: #b20000;
                  margin-left: 5px;
                  font-size: 11px;
                  top: -2px;
                "
              />
            </h5>
            <h5
              v-if="mobileDownload"
              class="col-lg-3 cursor-pointer down-option"
              @click="download(false)"
            >
              {{ "Mobile" }}
              <font-awesome
                :icon="['fas', 'download']"
                size="sm"
                style="
                  color: #b20000;
                  margin-left: 5px;
                  font-size: 11px;
                  top: -2px;
                "
              />
            </h5>
          </div>
        </template>
      </v-modal>
    </Teleport>
  </ClientOnly>
</template>

<script lang="ts" setup>
import VModal from "@/components/Modais/Modal.vue";
import translateModel from "@/tradutors/model";

const props = defineProps({
  model: {
    type: Object,
    required: true,
  },
  cardWallpapers: {
    type: Object,
    required: true,
  },
});
const route = useRoute();
const translate = computed(() =>
  route.params.language == "pt-br"
    ? translateModel.portugues
    : translateModel.ingles
);

const name = computed(() => props.model.nameModel);
const text = computed(() => props.model.text);
const cards = computed(() => props.cardWallpapers.cardsWallPappers);
const showModal = ref(false);
const imgSelected = ref("");
// Os links de download chegam só com a resposta do cliente (o SSR traz só a
// capa): seguem o card selecionado, para aparecer mesmo se o clique vier antes.
const idSelecionado = ref<number | null>(null);
const cardSelecionado = computed(() =>
  cards.value?.find((card: any) => card.id === idSelecionado.value),
);
const desktopDownload = computed(() => cardSelecionado.value?.imgDesktop ?? "");
const mobileDownload = computed(() => cardSelecionado.value?.imgMobile ?? "");

function openModal() {
  showModal.value = !showModal.value;
}
function selectedWallpaper(card: any) {
  imgSelected.value = card.imgPath;
  idSelecionado.value = card.id;
  openModal();
}
function download(val: boolean) {
  if (val) window.open(desktopDownload.value);
  else window.open(mobileDownload.value);
}
</script>
<style scoped lang="css">
:deep(.modal-container) {
  width: 500px;
}
.title {
  color: #000000;
  font-family: "Bebas-Neue";
  font-size: 72px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 72px;
}

.description {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}

.card-title {
  cursor: pointer;
  height: 19px;
  color: #666666;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
}

.card-wallpaper-view {
  width: 100%;
  height: 300px;
}

.img-selected-modal {
  width: 100%;
}

.down-option {
  height: 19px;
  color: #666666;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
}

.text {
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  max-width: 370px;
}

.descricao-mobile {
  display: none;
}

/* mesmo corte do isMobile() (< 770) */
@media screen and (max-width: 769px) {
  .descricao-desktop {
    display: none;
  }
  .descricao-mobile {
    display: inline;
  }
}

/* regras mobile 992vp */
@media screen and (max-width: 992px) {
  .card-wallpaper-view {
    width: 100%;
    height: unset;
  }

  .title, .text {
    display: none;
  }

  .description {
    font-weight: 300;
    font-size: 20px;
  }

  .block {
    padding: 10px;
  }

  .cards-wp {
    margin-top: 5px !important;
  }

  .div-top {
    margin-top: 20px !important;
  }

  :deep(.modal-container) {
    width: 95%;
  }
}
</style>
